//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ProfileMir from '~/components/profile/ProfileMir'
import ProfileMirHasCard from '~/components/profile/ProfileMirHasCard'
import ProfileMirNoCard from '~/components/profile/ProfileMirNoCard'
import Achievement from '~/components/profile/Achievement'
import ProfileDetailDonation from '~/components/profile/ProfileDetailDonation'
require("vue2-scrollbar/dist/style/vue2-scrollbar.css")
import { getArrForTitle } from '~/utils/utils';
import Patron from '~/components/forms/Patron'
import PatronImage from '~/components/forms/PatronImage'
import BecamePatron from '~/components/forms/BecamePatron'
import MasterpieceRecieved from '~/components/other/MasterpieceRecieved'
import MtModal from '~/components/Modal/MtModal'
import MtModalFull from '~/components/Modal/MtModalFull'

export default {
  components: {
    MtModalFull,
    MtModal,
    MasterpieceRecieved,
    BecamePatron,
    PatronImage,
    Patron,
    ProfileMir,
    ProfileMirNoCard,
    ProfileMirHasCard,
    Achievement,
    ProfileDetailDonation
  },
  props: {
    myProfileData: {
      type: Object,
      require: true,
      default: () => {}
    }
  },
  data() {
    return {
      masterpiece: null,
      // masterpiece: {
      //   author: "Саврасов ",
      //   id: "11054",
      //   name: "Домик в провинции. Весна",
      //   picture: "https://cdn.tretyakov.ru/mytretyakov/25/4cc4b003a2a79861cf4724ed23236e4f/thumb/053e2bcf1e909e2ac7b3623d0f3fc369_x1.png",
      //   year: "1878",
      // },
      masterpieceForPatron: null,
      modal: null
    }
  },
  computed: {
    getCurrentAvailableCount() {
      const availableMirMasterpiecesCount = this.myProfileData.loyaltyProgramData.availableMirMasterpiecesCount || 0
      const addedMirMasterpieces = this.myProfileData.loyaltyProgramData.addedMirMasterpieces || 0
      return availableMirMasterpiecesCount - addedMirMasterpieces
    }
  },
  mounted() {
    if (this.$route.query.hasOwnProperty('gpbPaymentStatus')) {
      this.sendPaymentInfo()
    } else if (this.$route.query.hasOwnProperty('gpbRecurrentStatus')) {
      if (this.$route.query.gpbRecurrentStatus === 'success') {
        this.modal = {
          title: this.$t('profile.cardAttachSuccessTitle'),
          message: 'Пожертвование будет списано в течение минуты. Шедевр будет добавлен в Вашу галерею сразу после успешного списания.',
          buttonColor: 'light',
          buttonAction: 'redirectToSettings',
          buttonText: this.$t('profile.cardAttachSuccessButtonText')
        }
        this.$axios({
          method: 'get',
          url: `/api/v1/donate/firstRecurringPaymentByOrderId/?orderId=${this.$route.query.orderId}`
        })
      } else {
        this.modal = {
          title: this.$t('profile.cardAttachErrorTitle'),
          message: this.$t('profile.cardAttachErrorMessage'),
          buttonColor: 'dark',
          buttonAction: 'retryPayment',
          buttonText: this.$t('profile.cardAttachErrorButtonText'),
        }
      }
    } else if (this.$route.query.hasOwnProperty('gpbPatronPaymentStatus')) {
      const { isGift, gpbPatronPaymentStatus, masterpieceId, orderId, ignoreApi } = this.$route.query
      // if (gpbPatronPaymentStatus === 'success') {
      //   if (ignoreApi) {
      //     this.openNewMasterpiece(masterpieceId)
      //   } else {
      //     this.$axios({
      //       method: 'get',
      //       url: `/api/v1/patronage/checkPaymentStatus?orderId=${orderId}&masterpieceId=${masterpieceId}&isGift=${isGift}&lang=${this.$i18n.locale || 'ru'}`
      //     })
      //       .then(({data}) => {
      //         if (data.data) {
      //           if (isGift === 'Y') {
      //             this.modal = {
      //               title: this.$t('profile.giftSentTitle'),
      //               message: this.$t('profile.giftSentMessage'),
      //               buttonText: this.$t('profile.giftSentButtonText'),
      //               buttonColor: 'light'
      //             }
      //           } else {
      //             this.openNewMasterpiece(masterpieceId)
      //           }
      //         }
      //       })
      //   }
      // } else {
      //   this.modal = {
      //     title: this.$t('profile.modalPaymentErrorTitle'),
      //     message: this.$t('profile.modalPaymentErrorMessage')
      //   }
      // }
      if (ignoreApi) {
        this.openNewMasterpiece(masterpieceId)
      } else {
        this.$axios({
          method: 'get',
          url: `/api/v1/patronage/checkPaymentStatus?orderId=${orderId}&masterpieceId=${masterpieceId}&isGift=${isGift}&lang=${this.$i18n.locale || 'ru'}`
        })
          .then(({data}) => {
            if (data.data) {
              if (isGift === 'Y') {
                this.modal = {
                  title: this.$t('profile.giftSentTitle'),
                  message: this.$t('profile.giftSentMessage'),
                  buttonText: this.$t('profile.giftSentButtonText'),
                  buttonColor: 'light'
                }
              } else {
                this.openNewMasterpiece(masterpieceId)
              }
            } else {
              this.modal = {
                title: this.$t('profile.modalPaymentErrorTitle'),
                // message: this.$t('profile.modalPaymentErrorMessage')
                message: data.error.message
              }
            }
          })
      }
    } else if (this.$route.query.hasOwnProperty('mirStatus')) {
      const { error, data } = this.$route.query
      let buttonText
      if (error) {
        buttonText = this.$t('profile.mirErrorButtonText')
      } else {
        buttonText = this.$t('profile.mirSuccessButtonText')
      }
      const completeTitle = this.$t('profile.mirSuccessTitle')
      const errTitle = this.$t('profile.mirErrorTitle')
      this.modal = {
        title: error ? errTitle : completeTitle,
        message: error || data,
        buttonText,
        buttonAction: error ? 'retryMir' : null,
        buttonColor: error ? 'dark' : 'light'
      }
    }
  },
  methods: {
    getTextArr(text) {
      return getArrForTitle(text)
    },
    closeMasterpieceRecieved() {
      this.masterpiece = null
      this.$router.replace({ path: this.$route.path })
    },
    sendPaymentInfo() {
      const { gpbPaymentStatus, orderId } = this.$route.query

      this.$axios({
        method: 'get',
        url: `/api/v1/donate/checkPaymentStatus/?orderId=${orderId}&gpbPaymentStatus=${gpbPaymentStatus}&lang=${this.$i18n.locale || 'ru'}`
      })
        .then(({data}) => {
          setTimeout(() => {
            if (data.data) {
              this.masterpiece = data.data
              this.$emit('updated')
            } else {
              this.modal = {
                title: this.$t('profile.modalPaymentErrorTitle'),
                // message: this.$t('profile.modalPaymentErrorMessage')
                message: data.error.message
              }
            }
          }, 5000)
        })
        .catch(err => {
          console.log('ERORRRR', err)
        })
    },
    buttonActions(type){
      this.modal = null
      this.$router.push('/profile/detail')
      switch(type) {
        case 'retryMir':
          this.$store.commit('openIframe')
          break
        case 'redirectToSettings':
          this.$router.push('/profile/settings#profilePayment')
          break
        case 'retryPayment':
          this.$store.commit('forms/openDonatForm')
          break
        default:
          return null
          break
      }
    },
    openNewMasterpiece(id) {
      this.$axios({
        method: 'get',
        url: `/api/v1/gallery/getById/?id=${id}&lang=${this.$i18n.locale || 'ru'}`,
      })
        .then(({data}) => {
          const { patron } = data.data
          if (patron && patron.currentUser) {
            this.masterpieceForPatron = data.data
          } else {
            this.$router.push(this.$route.path)
          }
        })
        .catch(err => {
          console.log('ошибка загрузке шедевра для патроната', err)
        })
    }
  }
}
